import { Component, OnInit, ElementRef, HostListener } from '@angular/core';
import { MyStripeService } from 'src/app/services/apiclient/myStripe/my-stripe.service';
import { ClientRefillsService } from 'src/app/services/apiclient/clientrefills/clientrefills.service';
import { ClientMerchantsService } from 'src/app/services/apiclient/clientmerchants/clientmerchants.service';
import { MatDialogConfig, MatDialog, MatDialogState } from '@angular/material/dialog';
import { ConfirmRechargeComponent } from '../../dialogs/confirm-recharge/confirm-recharge.component';
import { MediaObserver } from '@angular/flex-layout';
import { forkJoin } from 'rxjs';
import { ConfirmBlockCardComponent } from '../../dialogs/confirm-block-card/confirm-block-card.component';
import { Router, ActivatedRoute } from '@angular/router';
import { CurrencyService } from 'src/app/services/manage/currency/currency.service';
import { Angulartics2 } from 'angulartics2';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { PaymentMethodsComponent } from '../../dialogs/payment-methods/payment-methods.component';
import { StripeWebComponent } from 'src/app/components/stripe-web/stripe-web.component';
import { PaymentsMethodsCardComponent } from '../../dialogs/payments-methods-card/payments-methods-card.component';
import { TranslateService } from '@ngx-translate/core';

import { loadStripe } from '@stripe/stripe-js';
import { MyPosComponent } from '../../my-pos/my-pos.component';
import * as moment from 'moment';
import { CapturedPaymentComponent } from '../../captured-payment/captured-payment.component';
import { NeptingService } from 'src/app/services/apiclient/nepting/nepting.service';
import { Location } from '@angular/common';
import {CssService} from "../../../services/css-service";
declare var Stripe: any;

@Component({
  selector: 'app-recharge',
  templateUrl: './recharge.component.html',
  styleUrls: ['./recharge.component.css']
})
export class RechargeComponent implements OnInit {

  stripe: any;

  clientCards$: any[] | any;
  currMerchant: any;
  merchantClient$: any;
  currCard$: any;
  refills$: any[] | any;
  amount: number | any;

  paymentType: string = "online";
  hasStripe: boolean | any;
  hasPaypal: boolean | any;

  loader: boolean = true;
  statusMessage: string = this.translate.instant('rechargeComponent.messageLoaderGetinfoCard');

  errorMessage: string | any;
  successMessage: string | any;
  successRecharge: boolean = false;
  error: string | any;
  clientCardLoader: boolean = true;
  //Payment methods
  showPaymentMethods: boolean = true

  currSM = {
    payment_type: "online",
  }
  success: any = false;

  payMethodvisible = true;
  myDial3ds: any;

  currPaymentChoice: any;

  successYavin: any = false;
  min: any = 10;
  max: any = 500;


  //paymentsuccess
  savedDataStripe$: any;
  payment_intent$: any;
  nowPayment: any;
  obserProgress: any;
  stopProgress: boolean = false;
  paiment_order_exist: boolean = false;

  maxcall = 0

  constructor(
    private cardApi: MyStripeService,
    private refillsApi: ClientRefillsService,
    private clientMerchantApi: ClientMerchantsService,
    private currencyMng: CurrencyService,
    private dialog: MatDialog,
    public cssService: CssService,
    public media: MediaObserver,
    private router: Router,
    private route: ActivatedRoute,
    private stripeApi: MyStripeService,
    private angulartics2: Angulartics2,
    private tools: ToolsService,
    private elementRef: ElementRef,
    private myStripeApi: MyStripeService,
    public translate: TranslateService,
    public NeptingService: NeptingService,
    private location: Location
  ) { }

  ngOnInit() {

    //Retour de paiement Nepting
    //TODO est-ce propre
    this.checkNepting();

    //Retour de paiement Stripe
    //TODO est-ce propre
    this.checkPaymentIntent();

    //Retour de paiement Yavin
    //TODO est-ce propre
    this.checkPaymentYavin();

    // Get selected card client
    this.cardApi.getCurrCard().subscribe(card => {
      this.currCard$ = card;

    });

    this.route.params.subscribe((params: any) => {

      // Un identifiant commerçant doit etre spécifié
      //TODO voir pour utilise le code marchant a la place comem sur l'écran de choix des points de vente
      if (params.merchantId) {

        forkJoin(
          this.clientMerchantApi.getMerchant(params.merchantId),
          this.clientMerchantApi.getMerchantClient(params.merchantId),
          // this.cardApi.getCards()
          this.cardApi.getPaymentMethod()
        ).subscribe(([merchant, merchantClient, cards]) => {


          this.currMerchant = merchant;
          this.merchantClient$ = merchantClient;

          this.clientCards$ = cards;
          this.clientCardLoader = false;

          this.currencyMng.setCurrCurrency(merchant.currency);


          /**
           * Check si un compte paypal et stripe existent
           */
          this.handlePaymentMethods(merchant.currency);

          this.loader = false;
        });
      }
      else {
        this.router.navigate(["/404", this.translate.instant('error404.Urlincomplet')]);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.obserProgress) {
      this.obserProgress.unsubscribe();
    }
  }

  // Retour arrière
  goBack(user?: any): void {
    if (user) {
      this.router.navigate(["/home/merchantOptions/" + user]);
    }
    else {
      this.router.navigate(["/home/merchantOptions/" + this.currMerchant.id_user]);
    }
  }

  goHistoryId(id: any): void {
    this.router.navigate(["/home/refills" + "/" + id]);
  }

  goSame(): void {
    this.tools.openSnackBar(this.translate.instant('booking.error_pay'), "warn", 10000);

    const url = window.location.pathname;
    this.router.navigate([url]);
  }

  /**
      * @description Check params
      * @returns {void}
      */
  checkNepting() {

    this.route.params.subscribe((params: any) => {

      //nepting
      if (params.nepting && params.payment) {
        this.statusMessage = this.translate.instant('rechargeComponent.recharg');
        this.loader = true;

        if (params.payment == "success") {


           this.goHistoryId(params.merchantId);

          let text:any=this.translate.instant('rechargeComponent.pay');

          this.tools.openSnackBar(text, "great", 4000, "bottom");
          this.amount = null;
          this.successRecharge = true;
          this.loader = false;

          return;
        }
        else if (params.payment == "cancel" || params.payment == "error" || params.payment == "refused") {

          this.translate.get("nepting." + params.payment).subscribe((trad: string) => {
            this.tools.openSnackBar(trad, "warn", 2000);
          })

          this.location.replaceState('home/recharge/' + params.merchantId);

        }

      }




    })

  }

  /**
   * @description Vérifie si on vient d'une redirection apres un paiement stripe element
   */
  checkPaymentIntent(): void {

    this.success = false;
    const url = new URL(window.location.href);

    const clientSecret = url.searchParams.get('payment_intent_client_secret');
    const status = url.searchParams.get('redirect_status');


    const that = this;
    this.savedDataStripe$ = that.tools.getStor("payment_save_recharge_stripe");


    if (clientSecret) {

      that.loader = true;
      /**
       * On récupère les données essentielles qui ont été sauvegardées avant la redirection vers le paiement
       */

      this.payment_intent$ = url.searchParams.get('payment_intent');
      if (this.savedDataStripe$) {
        if (status === "succeeded") {
          that.statusMessage = this.translate.instant('rechargeComponent.recharg');
          this.success = true;
          this.nowPayment = moment();
          this.progressPaymentObservable();
          that.myStripeApi.setProgressPaymentStripe(true);


        }
        else {
          that.loader = false;
          this.savedDataStripe$ = null;
          that.tools.removeStor("payment_save_recharge_stripe");
          that.goSame();

        }


        return;
      }

    }
    else {
      if (this.savedDataStripe$) {
        //check
        this.checkOrderPayment();
      } else {

        //page refresh
        that.tools.removeStor("payment_save_recharge_stripe");
      }
    }


  }

  /**
  * @description Vérifie si on vient d'une redirection apres un paiement yavin
  */

  checkPaymentYavin(): void {

    this.successYavin = false;
    const url = new URL(window.location.href);
    const yavin = url.searchParams.get('cartId');
    const status = url.searchParams.get('status');

    const that = this;


    if (yavin) {


      //***********  status possible***********

      // pending : En attente de paiement.
      // ok : Paiement réussi.
      // authorised : Payé mais contient une ou plusieurs transactions autorisées nécessitant une capture.
      // ko : Le panier a été annulé.

      //status !== 'ko'
      if (status == 'ok' || status == 'authorised') {
        that.statusMessage = this.translate.instant('rechargeComponent.recharg');
        this.successYavin = true;


        //yavin

        that.refillsApi.yavinRefillPaymentSucceeded(yavin, status).then((data: any) => {



          if (data && data.code == 0 || data.code == -7) {

            that.merchantClient$ = data.client_user;
            // that.goBack(data.client_user.id_user);
            that.goHistoryId(data.client_user.id_user);

            let text: any = data.code == -7 ? this.translate.instant('rechargeComponent.payed') : this.translate.instant('rechargeComponent.pay');

            that.tools.openSnackBar(text, "great", 4000, "bottom");
            that.amount = null;
            that.successRecharge = true;
            that.loader = false;

          }

          else {
            that.loader = false;
            that.goSame();
          }
        });
      }
      else {

        that.loader = false;
        that.goSame();
      }



      return;
    }

  }





  /**
   * @description Recharge une carte via stripe
   * @param {string} payment_intent_id
   * @returns {void}
   */
  rechargeCard(payment_intent_id?: string): void {


    const that = this;

    that.successMessage = null;
    that.successRecharge = false;
    that.errorMessage = null;
    that.statusMessage = this.translate.instant('rechargeComponent.recharg');
    that.loader = true;

    that.refillsApi.creditCard(that.paymentType, that.amount, that.currCard$, that.currMerchant.id_user, null, payment_intent_id).then((data) => {


      if (data.code === 0) {

        that.merchantClient$ = data.client_user;

        that.goHistoryId(data.client_user.id_user);

        that.tools.openSnackBar(this.translate.instant('rechargeComponent.pay'), "great", 4000, "bottom");
        that.amount = null;
        that.loader = false;
        that.successRecharge = true;


        // //on ferme le popup 3dssecure
        // if (this.myDial3ds && this.myDial3ds.getState() === MatDialogState.OPEN) {
        //   this.myDial3ds.close();
        // }
      } else if (data.code === -2) {

        this.tools.setStor("ClientKeyPayIntenCard", data.pi);
        //ancienne methode

        that.angulartics2.eventTrack.next({
          action: '3DSecureNeeded',
          properties: { category: 'rechargeCard' },
        });

        that.stripe.handleCardAction(
          data.payment_intent_client_secret
        ).then(function (result: any) {

          if (result.error) {

            that.errorMessage = result.error.message;
            that.loader = false;

          } else {

            that.confirmRecharge(result.paymentIntent.id);

          }

        });

      }
      else if (data.code == -3) {
        this.tools.setStor("ClientKeyPayIntenCard", data.pi);
        //3d secure
        that.angulartics2.eventTrack.next({
          action: '3DSecureNeeded',
          properties: { category: 'rechargeCard' },
        });

        that.stripe.confirmCardPayment(
          data.payment_intent_client_secret,
          {
            payment_method: data.pi.payment_method,
          },

        ).then(function (result: any) {
          if (result.error) {

            that.errorMessage = result.error.message;
            that.loader = false;

          } else {

            if (result.paymentIntent.status == "succeeded") {

              that.confirmRecharge(result.paymentIntent.id);
            };
          }
        })





      }
      else {

        if (data && data.code && data.code === -134) {
          this.tools.openSnackBar(this.translate.instant('credit_due.nogoodPayMethod'), ['warn'], 4000);
          this.loader = false
        }
        if (data && data.code && data.code == -60) {
          //pas de client
          this.tools.openSnackBar(this.translate.instant('nocustomers'), ['warn'], 4000);
          this.loader = false;

        }


        if (data && data.code && data.code === -1000) {
          if (data.err && data.err.jsonBody && data.err.jsonBody && data.err.jsonBody.error && data.err.jsonBody.error.message) {
            data.message = this.translate.instant('rechargeComponent.error3d')
            // data.message += "(" + data.err.jsonBody.error.message + ")";
            data.message += " \n \n " + this.translate.instant('rechargeComponent.error_stripe');
          }
          this.tools.openSnackBar(data.message ? data.message : this.translate.instant('booking.error_pay'), "warn", 10000);
          this.loader = false;
        }
        else {

          this.errorMessage = data.message;
          this.loader = false;
        }

      }

    });

  }

  //yavin

  /**
  * @description pour recharge via yavin link payment
  * @param amount
  *  @param id_user
  * @returns {void}
  */
  rechargeLinkYavin() {

    //creation advance_payment et paiement  yavin link paiement
    this.refillsApi.refillsYavinPayment(this.amount, this.currMerchant.id_user).then((data) => {

      if (data.code === 0) {
        window.location.href = data.yavin_link.payment_link;
        return;

      }
      else {

        this.tools.openSnackBar(data.message ? data.message : this.translate.instant('booking.error_pay'), "warn", 10000);
      }


    })
  }

  /**
   * @description pour recharge via yavin link payment
   * @param amount
   *  @param id_user
   * @returns {void}
   */
  rechargeMypos() {

    //creation advance_payment et refill_id
    this.refillsApi.refillsMyposPayment(this.amount, this.currMerchant.id_user).then((data) => {

      if (data.code === 0) {
        //open
        this.openMyPosPayment(data);
      }
      else {
        //data messge minimum max -122

        this.tools.openSnackBar(data.message ? data.message : this.translate.instant('booking.error_pay'), "warn", 10000);
      }


    })
  }


  /**
 * @description pour recharge rechargeNepting
 * @param amount
 *  @param id_user
 * @returns {void}
 */
  rechargeNepting() {

    //creation advance_payment et refill_id
    this.refillsApi.refillsNeptingPayment(this.amount, this.currMerchant.id_user).then((data) => {

      this.loader=true;

      if (data.code === -90) {
        this.loader=false;
        //open
        this.NeptingService.getForm(data);
      }
      else {
        this.loader=false;
        //data messge minimum max -122

        this.tools.openSnackBar(data.message ? data.message : this.translate.instant('booking.error_pay'), "warn", 10000);
      }


    })
  }

  /**************
  * myPos
  * ************/
  openMyPosPayment(data?: any, payment_intent_id?: any): void {


    let that: any = this;

    let dataRefill: any = {
      paymentType: this.paymentType,
      currCard$: this.currCard$,
      metadata: 3,//provenance recharge
      payment_intent_id: payment_intent_id
    }


    that.loader = true;

    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;

    myConf.data = {
      amount: this.amount,
      id_user: this.currMerchant.id_user,
      metadata: 3,  //provenance refill,
      dataRefill: dataRefill,
      mypos_account: data.mypos_account,
      refill_intent_id: data.client_recharge.id

    };




    this.media.isActive("xs")
      ? (myConf.width = "100%", myConf.height = "100%")
      : (myConf.width = "550px", myConf.minHeight = "500px");
    const myDial = this.dialog.open(MyPosComponent, myConf);
    myDial.afterClosed().subscribe((result) => {

      this.tools.setOnPopState(true);


      if (result && result.success) {
        this.loader = true;
        this.setPaymentMypos(result.success.OrderID, result.success);
      }
      else {
        this.loader = false;
      }



    });



  }

  setPaymentMypos(order_id: any, paiement: any) {


    let that = this;
    that.refillsApi.MyposRefillPaymentSucceeded(paiement, order_id).then(refill => {

      if (refill && refill.code === 0 || refill.code == -7) {
        that.successPaymentCredit(refill);
      }
      else {
        this.loader = false;
        //error
      }


    }).catch(err => {
      console.error('err', err)

    })


  }


  successPaymentCredit(data: any) {
    if (data && data.code == 0 || data.code == -7) {

      this.merchantClient$ = data.client_user;
      this.goHistoryId(data.client_user.id_user);

      let text: any = data.code == -7 ? this.translate.instant('rechargeComponent.payed') : this.translate.instant('rechargeComponent.pay');

      this.tools.openSnackBar(text, "great", 4000, "bottom");
      this.amount = null;
      this.successRecharge = true;
      this.loader = false;
    }

    else {
      this.loader = false;
      this.goSame();
    }
  }

  /**
   * @description En cas de check SCA, appelle la rechargeCard method avec en parametre un payment intent id
   * @param {string} payment_intent_id
   * @returns {void}
   */
  confirmRecharge(payment_intent_id?: string): void {
    this.rechargeCard(payment_intent_id);
  }

  /**
   * @description Recharge une carte via paypal
   * @param {string} paypal_order_id
   * @returns {void}
   */
  rechargeCardPaypal(paypal_order_id?: string): void {


    const that = this;

    that.successMessage = null;
    that.successRecharge = false;
    that.errorMessage = null;
    that.statusMessage = this.translate.instant('rechargeComponent.recharg');;
    that.loader = true;

    that.refillsApi.creditCard(that.paymentType, that.amount, null, that.currMerchant.id_user, paypal_order_id).then((data) => {

      if (data.code === 0) {

        that.merchantClient$ = data.client_user;
        // that.goBack();
        that.goHistoryId(data.client_user.id_user);
        that.tools.openSnackBar(this.translate.instant('rechargeComponent.pay'), "great", 4000, "bottom");

        that.amount = null;
        that.loader = false;
        that.successRecharge = true;

      } else {

        if (data && data.code && data.code === -134) {
          this.tools.openSnackBar(this.translate.instant('credit_due.nogoodPayMethod'), ['warn'], 4000);
          this.loader = false
        }
        if (data && data.code && data.code == -60) {
          //pas de client
          this.tools.openSnackBar(this.translate.instant('nocustomers'), ['warn'], 4000);
          this.loader = false;

        }
        else {
          this.errorMessage = data.message;
          this.loader = false;
        }

      }

    });

  }

  blockCard(): void {

    this.successMessage = null;
    this.errorMessage = null;

    this.statusMessage = this.translate.instant('rechargeComponent.messageLoaderBlockCard');
    this.loader = true;

    this.refillsApi.blockCard(this.currMerchant.id_user).then(data => {

      if (data.code === 0) {

        // Update merchant client
        this.merchantClient$ = data.client_user;
        this.goBack();
        this.tools.openSnackBar(this.translate.instant('rechargeComponent.messageLoaderBlockCardSuccess'), "great", null, "bottom");

      } else {

        this.errorMessage = data.message;

      }

      this.loader = false;

    });

  }

  unblockCard(): void {

    this.successMessage = null;
    this.errorMessage = null;

    this.statusMessage = this.translate.instant('rechargeComponent. messageLoaderUnblockCard');
    this.loader = true;

    this.refillsApi.unblockCard(this.currMerchant.id_user).then(data => {

      if (data.code === 0) {

        // Update merchant client
        this.merchantClient$ = data.client_user;
        this.goBack();
        this.tools.openSnackBar(this.translate.instant('rechargeComponent. messageLoaderBlockCardSuccess'), "great", null, "bottom");

      } else {

        this.errorMessage = data.message;

      }

      this.loader = false;

    });

  }


  RechargeDial() {

    // check min or max
    if (!this.amount || (this.amount && this.amount < this.min) || (this.amount && this.amount > this.max)) {
      let message = !this.amount ? 'booking.error_pay' : this.amount < this.min ? 'amountrefill.min' : 'amountrefill.max';
      this.tools.openSnackBar(this.translate.instant(message), "warn", 4000);
      return;
    }


    this.currSM.payment_type === 'stripe' ? this.openStripePayment() :
      this.currSM.payment_type === 'yavin' ? this.rechargeLinkYavin() :
        this.currSM.payment_type === 'myPos' ? this.rechargeMypos() :
          this.currSM.payment_type === 'nepting' ? this.rechargeNepting() :
            this.openConfirmRechargeDial();

  }


  openConfirmRechargeDial(): void {

    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {


      amount: this.amount,
      card: this.currCard$,
      paymentType: this.paymentType,
      currMerchant: this.currMerchant
    };

    this.media.isActive("xs") ? myConf.width = "100%" : myConf.minWidth = "400px";
    const myDial = this.dialog.open(ConfirmRechargeComponent, myConf);
    myDial.afterClosed().subscribe((result) => {
      if (result) {

        this.paymentType === "online" ? this.rechargeCard() : this.rechargeCardPaypal(result);


      }

    });

  }

  /**
  * @description ouvre la pop up stripe paiement
  */


  openStripePayment(payment_intent_id?: any): void {



    let dataRefill: any = {
      paymentType: this.paymentType,
      currCard$: this.currCard$,
      metadata: 3,//provenance recharge
      payment_intent_id: payment_intent_id
    }
    this.loader = true;



    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {
      amount: this.amount,
      // client_recharge_id: data.client_recharge.id,
      id_user: this.currMerchant.id_user,
      metadata: 3,  //provenance refill,
      dataRefill: dataRefill,
      stripe: this.stripe
    };
    // console.log("recharge.component - openStripePayment -  myConf.data : ",  myConf.data);

    const myDial = this.dialog.open(StripeWebComponent, myConf);
    myDial.afterClosed().subscribe((result) => {

      this.tools.setOnPopState(true);
      this.loader = false;


      if (!result || result && result.error) {
        //unmount
        this.unmountStripe();
        this.tools.removeStor("payment_save_recharge_stripe");

        if (result && result.error) {
          this.openDialogStatusStripeCapuredSucceded(result.error);
        }
      }



    });



  }


  openDialogStatusStripeCapuredSucceded(error?: any) {




    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.disableClose = true;

    myConf.data = {
      error: error,
      recharge: true

    };



    this.media.isActive("xs")
      ? (myConf.width = "100%", myConf.height = "100%")
      : (myConf.width = "80%", myConf.height = "80%");
    const myDial = this.dialog.open(CapturedPaymentComponent, myConf);

    myDial.afterClosed().subscribe((result) => {
      this.tools.removeStor("ClientKeyPayIntentRefill");

    })

  }


  unmountStripe() {
    //let elestripe: any = this.stripeApi.resetPaymentElement();

  }

  openConfirmBlockCard(block: boolean): void {
    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {
      block: block
    };
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.width = "500px";
    const myDial = this.dialog.open(ConfirmBlockCardComponent, myConf);
    myDial.afterClosed().subscribe((result) => {
      if (result) {
        block ? this.blockCard() : this.unblockCard();
      }
    });
  }

  setClientCards(cards: any,) {
    this.clientCards$ = cards;
  }

  /**
   * @description Check les methodes de paiement valides
   * @param {any} currency
   * @returns {void}
   */
  handlePaymentMethods(currency: any): void {

    let stripeAccount: any = null;
    let paypalAccountId: any = null;
    if(this.currMerchant.paypal_account){
      this.hasPaypal = true;
      paypalAccountId = this.currMerchant.paypal_account;
      this.currSM.payment_type = 'online_paypal';
    }

    if (this.currMerchant.stripe_account) {
      stripeAccount = this.currMerchant.stripe_account;
      this.currSM.payment_type = 'online';
      this.hasStripe = true;

    }



    /**
    * Si compte paypal
    */
    if (this.hasPaypal) {

      this.initScriptPaypal(currency, paypalAccountId);
    }

    /**
     * Si compte stripe
     */
    if (this.hasStripe) {

      this.stripeApi.getStripeKey().subscribe(async key => {

        if (key) {
          // this.stripe = Stripe(key, { stripeAccount: stripeAccount });
          this.stripe = await loadStripe(key);

        }
      });
    }
    this.currPaymentChoice = this.currSM.payment_type;


  }

  /**
    * @description Set le choix de paiement provient emi autre components
    * @param {string} paymentType

    */
  setPaymentChoice_(paymentChoice: any) {
    this.setPaymentType(paymentChoice);
  }


  /**
   * @description Set le choix de paiement (Stripe ou paypal)
   * @param {string} paymentType
   * @returns {void}
   */
  setPaymentType(paymentType?: any): void {
    this.paymentType = paymentType;
    this.currSM.payment_type = paymentType;

  }

  payMethod(paymentsMethods: any) {

    let visible = paymentsMethods.find((value: any) => value.visible)
    this.payMethodvisible = visible ? true : false;

  }

  /**
  * @description Initialise le sdk paypal
  * @returns {void}
  */
  initScriptPaypal(currency: any, paypalAccountId: any): void {

    var s = document.createElement("script");
    s.src = "https://www.paypal.com/sdk/js?client-id=" + paypalAccountId + "&currency=" + currency.shortname;
    this.elementRef.nativeElement.appendChild(s);

  }



  /**
    * @description Ouvre la dialog de selection de methode de paiement
    * @returns {void}
    */
  openPaymentMethodsDial(): void {



    if (!this.clientCardLoader) {
      const myConf = new MatDialogConfig();
      myConf.data = {

        clientCards: this.clientCards$,
        currMerchant: this.currMerchant,
        payment_type: this.currSM.payment_type,
        popupMode: true,
      };

      this.media.isActive("xs")
        ? (myConf.width = "100%", myConf.height = "100%")
        : (myConf.width = "550px", myConf.minHeight = "500px");

      const myDial = this.dialog.open(PaymentMethodsComponent, myConf);

      //changed
      this.tools.setOnPopState(true);

      myDial.afterClosed().subscribe((result) => {
        if (result) {

          this.clientCards$ = result.cards;
          this.setPaymentType(result.payment_method);
        }
      });
    }
  }


/**
   * @description openCardMethodsDial
   * @param ev
    */

  openCardMethodsDial(ev: any) {


    if (!this.clientCardLoader) {
      const myConf = new MatDialogConfig();
      myConf.data = {
        clientCards: this.clientCards$,
        card: ev,
        pos: this.currMerchant,
        sm: this.currSM
      };
      // console.log("recharge.component - openCardMethodsDial -  myConf.data : ",  myConf.data);


      this.media.isActive("xs")
        ? (myConf.width = "100%", myConf.height = "100%")
        : (myConf.width = "550px", myConf.height = "80%");

      const myDial = this.dialog.open(PaymentsMethodsCardComponent, myConf);

      //changed
      this.tools.setOnPopState(true);

      myDial.afterClosed().subscribe((result) => {

        if (result) {
          this.clientCards$ = result.cards;
          this.setPaymentType(result.payment_method);


        }
      });
    }

  }



  /**
     * @description observable  Payment Stripe
     *
     */

  progressPaymentObservable() {
    let that = this;
    that.obserProgress = this.myStripeApi.getProgressPaymentStripe().subscribe(value => {
      if (value) {

        {
          if (this.savedDataStripe$ && this.payment_intent$)

            that.getProgressPayment();
        }
      }
    });
  }


  /**
   * @description check in order payment -> captured
   *
   */
  getProgressPayment() {


    this.maxcall++;
    //check oderPayment in base is captured
    this.myStripeApi.getOrderPaymentStripe(null, this.savedDataStripe$.client_recharge_id, this.payment_intent$).then((data: any) => {

      let time_Exceeded = this.maxcall > 10 ? true : this.myStripeApi.checkTimeExceeded(this.nowPayment);

      if (data && data.code < 0 || time_Exceeded || data.orderPayment && data.orderPayment.captured && data.orderPayment.captured == 1) {

        //stop intervall
        this.myStripeApi.stopIntervalProgressPayment();
        //message ok ou ko
        this.finalStatusBeforeClose(data);

      }

      else {

        //start call
        this.myStripeApi.startIntervalProgressPayment();

      }

      return;
    });

  }

  /**
     * @description Status Before Close
     *@params infoStatus
     */

  finalStatusBeforeClose(infoStatus: any) {


    if (this.stopProgress) {
      return;
    }

    //error infoStatus.code <0
    // time out  time_Exceeded let time_Exceeded = this.myStripeApi.checkTimeExceeded(this.nowPayment);
    // captured  infoStatus.orderPayment.captured



    if (infoStatus.orderPayment && infoStatus.orderPayment.captured && infoStatus.orderPayment.captured == 1) {
      this.statusMessage = this.translate.instant('rechargeComponent.recharg');
      this.success = true;
      this.stopProgress = true;
      let text: any = this.translate.instant('rechargeComponent.pay');
      this.tools.openSnackBar(text, "great", 4000, "bottom");
      this.amount = null;
      this.successRecharge = true;
      this.tools.removeStor("ClientKeyPayIntentRefill");
      this.tools.removeStor("payment_save_recharge_stripe");
      this.loader = false;
      this.goHistoryId(infoStatus.orderPayment.id_user);


    }
    else {
      this.checkOrderPayment();
    }

    return;


  }

  /**
     * @description check in order payment -> captured if problem
     *
     */

  checkOrderPayment() {
    this.loader = true;

    this.myStripeApi.checkOrderPayment(null, this.savedDataStripe$.client_recharge_id, this.savedDataStripe$.payment_intent).then((data: any) => {



      if (data && data.code >= 0 && (data.orderPayment
        && data.orderPayment.captured == 1 && data.paiement && data.paiement.status ==
        "succeeded")) {


        this.paiment_order_exist = true;
        this.tools.removeStor("ClientKeyPayIntentRefill");
        this.tools.removeStor("payment_save_recharge_stripe");
        this.savedDataStripe$ = null;
        let text: any = this.translate.instant('rechargeComponent.pay');
        this.tools.openSnackBar(text, "great", 4000, "bottom");
        this.amount = null;
        this.successRecharge = true;

        this.loader = false;
        this.goHistoryId(data.orderPayment.id_user);



      }


      else {

        //on efface
        this.loader = false;
        this.tools.removeStor("payment_save_recharge_stripe");
        this.savedDataStripe$ = null;


      }
      return;
    });

  }


}
